import { SignUp } from "../src/platform/views/Auth/SignUp";
import { NextHead } from "../src/landingPage/layouts/LayoutComponents/NextHead";
import Provider from "../src/redux/Provider";

const SignUpPage = ({ initialReduxState }) => {
  return (
    <Provider.Redux initialReduxState={initialReduxState}>
      <NextHead
        currentPath="/sign-up"
        title="Sign Up"
        description="Sign up to the Demyst Platform and get into production with a custom-configured Data API."
      />
      <SignUp />
    </Provider.Redux>
  );
};

export default SignUpPage;
